document.addEventListener("DOMContentLoaded", (e) => {
    const loader = document.querySelector('.loader-container')

    WishlistInit()

    loader.remove()
});

function WishlistInit() {
   const code = `<div class="PaddingFlow">
        <div class="lg:text-[64px] max-lg:text-[32px] text-[#000] font-medium lg:text-center max-lg:text-left">${SHOP_LOCALE[window.Shopify.locale]}</div>
      </div>`
   const store = JSON.parse(localStorage?.favorites)
   const Products = document.querySelectorAll('.product-class')
   const list = document.querySelector('.container-rs .mt-6')

   let finded = false

   Products.forEach((product) => {
      for(let pid of store) {
         if(product.dataset.productId == pid) {
            finded = true
            product.classList.remove('hidden')
         }
      }
   })

   if(finded == false) {
       list.insertAdjacentHTML('afterbegin', code)
    }
}